/**
 * Enum for terminal transaction status.
 * @readonly
 * @enum {Object} TerminalTransactionStatusEnum
 */

const TerminalTransactionStatusEnum = {
  PENDING  : {Id: 1, Code: 'PENDING'},
  SENT     : {Id: 2, Code: 'SENT'},
  COMPLETED: {Id: 3, Code: 'COMPLETED'}
}

export default TerminalTransactionStatusEnum
